import { border } from "@mui/system";
import dayjs from "dayjs";
export const BASE_API_URL = "https://insightabanotes-dmg4fpdcfrhwfwfx.canadaeast-01.azurewebsites.net/api";
//"http://localhost:8080/api";
export const MALADAPTIVE_BEHAVIORS = ["Aggression", "Self-injury", "Tantrum"];
export const REINFORCERS = [
  "Favorite snacks",
  "Yoga sessions",
  "Educational games",
  "Spin the wheel",
];
export const SKILL_STRATEGIES = [
  "Puppet Play",
  "Brain Gym Game",
  "Shaping/Chaining",
];
export const BEHAVIOR_INTERVENTIONS = [
  "Physical Guidance",
  "First/Then Statements",
];
export const PRIMARY_TARGET_AREAS = ["Concentrate", "Emotional regulation"];
export const CLIENT_MOOD_AND_RESPONSE = [
  "Curious and exploring",
  "Playful and jovial",
];
export const PARTICIPANTS = ["Therapist", "Client's parent"];
export const NEXT_SESSION_PLANS = [
  "Continue skill-building activities",
  "Review progress on behavior goals",
];
export const textFieldStyles = (value) => ({
  "& .MuiOutlinedInput-root": {
    ...(value === "100" && {
      "& fieldset": {
        borderColor: "green",
      },
      "&:hover fieldset": {
        borderColor: "green", // Maintain green border on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "green", // Maintain green border when focused
      },
    }),
  },
});

export const buttonStyle = {
  minWidth: "140px", // Sets a minimum width for the buttons
  height: "40px", // Sets the height for the buttons
  backgroundColor: "orange",
  color: "white",
  padding: "10px 20px",
  margin: "5px",
  fontSize: "16px",
  "&:hover": { backgroundColor: "darkorange" },
};

export const themeStyles = {
  textField: {
    "& .MuiInputBase-root": {
      color: "black",
      // Ensure the background color is set to white or any other color you need
      boxShadow: "0px 3px 6px #00000029", // Customize the drop shadow as needed
      borderRadius: "5px",
      borderColor: "#e9a132",

      "& input": {
        color: "white",
      },
      // Removed border styling, as we're now using a drop shadow
    },
    "& .MuiInputLabel-root": {
      color: "white",
      // Style adjustments for when the input is focused or has a value
      "&.Mui-focused": {
        color: "white",
      },
    },
    // Remove the underline styling as we're focusing on drop shadow
    "& .MuiFilledInput-underline:before": {
      display: "none",
    },
    "& .MuiFilledInput-underline:after": {
      display: "none",
    },
    // Adjust the label to move properly when the input is focused
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      backgroundColor: "none",
      padding: "0 4px",
    },
    // Apply the drop shadow to the notched outline as well for consistency
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "white", // Default border color
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(233, 161, 50, 0.8)", // Lighter or different color on hover
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(233, 161, 50, 1)", // Darker or different color on focus
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(233, 161, 50, 0.8)", // Ensure hover effect in consistency
    },
    "& .MuiInputLabel-filled": {
      color: "white", // Placeholder/Label color
    },
    "& .MuiInputLabel-filled.Mui-focused": {
      color: "white", // Ensures label color remains white when focused
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "white", // Clear button color
    },
    "& .MuiAutocomplete-popupIndicator": {
      color: "white", // Dropdown button color
    },
    "& .MuiSvgIcon-root": {
      color: "white", // Calendar button color
    },
  },
  // constants.js

  autocompleteStyles: {
    "& .MuiInputBase-root": {
      color: "black",
      backgroundColor: "transparent",
      borderColor: "black",
      borderWidth: "3px",
      borderStyle: "solid",
      borderRadius: "10px",
      "& input": {
        color: "black",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "black",
      },
    },
    "& .MuiInputLabel-root": {
      color: "black",
    },
    "& .MuiFilledInput-underline:before": {
      borderBottomColor: "black",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: "black",
    },
    gridColumn: "span 2",
  },
};

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto", // Set the width as required
  maxWidth: "80vw",
  maxHeight: "80vh",
  overflowY: "auto", // In case the content is too big
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const collectionTypeColors = {
  baseline: "#FF0000", // Red
  mastery: "#00FF00", // Green
  practicing: "#0000FF", // Blue
  maintenance: "#FFFF00", // Yellow
  default: "#000000", // Black for any other or undefined collectionType
};
export function formatTimestamp(timestamp) {
  // Check if the timestamp seems to be in seconds and adjust if necessary
  return dayjs(timestamp < 10000000000 ? timestamp * 1000 : timestamp).format(
    "YYYY-MM-DD"
  );
}
